export default "__VITE_ASSET__bc7fb90f__"